/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
// import IconBoxes from '../../../../../components/iconBoxes.js';
// import Panel from '../../../../../components/panel.js';
// import SimpleAreaChart from '../../../../../charts/simpleAreaChart.js';
// import SimpleLineChart from '../../../../../charts/simpleLineChart.js';
// import TableComponent from '../../../../../containers/table.js';
import { HideClientPasswordStatusMessage } from '../actions/ClientDashboardActions';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class ClientDashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessage: true,
    };
    this.hideMessageClick = this.hideMessageClick.bind(this);
  }

  hideMessageClick() {
    this.setState({ showMessage: false });
    this.props.HideClientPasswordStatusMessage();
  }

  render() {
    return (
      <div>        
        <ReactCSSTransitionGroup
          transitionName="toggle"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}>
          {this.state.showMessage && this.props.passwordExpiryMessage ?
            <div className={'alert ' + this.props.passwordExpiryColorCode + ' update-pwd'}>
              {this.props.passwordExpiryMessage}
              <i onClick={this.hideMessageClick} className="fa fa-times" aria-hidden="true"></i>
            </div>
            : null}
        </ReactCSSTransitionGroup>
        {/* <IconBoxes/>        
        <div className="row">
          <div className="col-md-6">
            <Panel
              title="Total Earns"
              righticon={true}
            >
              <SimpleAreaChart/>
            </Panel>
          </div>

          <div className="col-md-6">
            <Panel
              title="Total Sales"
              righticon={true}
            >
              <SimpleLineChart/>
            </Panel>
          </div>
        </div>

         <Panel
          title="User Table"
          righticon={true}
        >
          <TableComponent/>
        </Panel> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginUserInfo: state.clientLogin.loginUserInfo,
    passwordExpiryMessage: state.patient_dashboard && state.patient_dashboard.passwordExpiryMessage ? state.staff_dashboard.passwordExpiryMessage : '',
    passwordExpiryColorCode: state.patient_dashboard && state.patient_dashboard.passwordExpiryColorCode ? state.staff_dashboard.passwordExpiryColorCode : '',
  };
};

export default connect(mapStateToProps, { HideClientPasswordStatusMessage })(ClientDashBoard);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/dashboard/components/client_dashboard.js